import { trackEvent as t } from '../track';
import { SelectAppProps } from './propertyTypes';

export const appSidebar = {
  selectActivityFeed: () => t('[App Sidebar] Select activity feed'),
  selectMyDocuments: () => t('[App Sidebar] Select my documents'),
  selectApp: (props: SelectAppProps) => t('[App Sidebar] Select app', props),
  selectProfileUser: () => t('[App Sidebar] Select profile user'),
};
